// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"329":"1993cf3e","670":"d6ae36d4","837":"b0829753"}[chunkId] + ".chunk.js");